import ContactDto from 'common/dto-types/contacts/contact-dto';
import { SortingType } from 'components/base-table/dto';
import { Column } from 'react-table';

const ContactTableColumnConfig = [
    {
        Header: 'Id',
        accessor: 'id',
        disableSortBy: false,
    },
    {
        Header: 'Contact Name',
        accessor: 'contactName',
    },
    {
        Header: 'First Name',
        accessor: 'firstName',
        disableSortBy: false,
    },
    {
        Header: 'Last Name',
        accessor: 'lastName',
        disableSortBy: false,
    },
    {
        Header: 'Phone',
        accessor: 'phone',
    },
    {
        Header: 'Email',
        accessor: 'email',
    },
    {
        Header: 'Avatar Url',
        accessor: 'avatarUrl',
    },
    {
        Header: 'preferredLanguages',
        accessor: 'Preferred Languages',
    },
    {
        Header: 'Facebook',
        accessor: 'facebookProfileUrl',
    },
    {
        Header: 'Twitter',
        accessor: 'twitterProfileUrl',
    },
    {
        Header: 'Instagram',
        accessor: 'instagramProfileUrl',
    },
    {
        Header: 'Youtube',
        accessor: 'youtubeProfileUrl',
    },
    {
        Header: 'Linkedin',
        accessor: 'linkedinProfileUrl',
    },
    {
        Header: 'Address',
        id: 'address',
        disableFilters: true,
        accessor: (row: ContactDto) => row.address?.address || row.address?.addressLine,
    },
    {
        Header: 'Contact Type',
        id: 'contactType',
        disableFilters: true,
        disableSortBy: false,
        accessor: (row: ContactDto) => row.contactType?.name,
    },
    {
        Header: 'Title',
        id: 'jobTitle',
        disableFilters: true,
        accessor: (row: ContactDto) => row.jobTitle?.name,
    },
    {
        Header: 'Location',
        accessor: 'location',
        disableSortBy: false,
    },
] as Column[];

export default ContactTableColumnConfig;

export const DefaultVisibleContactColumns = [
    'contactName',
    'firstName',
    'lastName',
    'jobTitle',
    'address',
    'contactType',
    'phone',
    'email',
    'note',
    'location',
];

export const SearchableContactTableColumnConfig = [
    'id',
    'contactName',
    'firstName',
    'lastName',
    'jobTitle',
    'address',
    'contactType',
    'phone',
    'email',
    'note',
    'location',
];

export const DefaultContactTableColumnIdToSortBy = 'firstName';
export const DefaultContactTableSortingType = SortingType.Ascending;
